import { onMounted, onBeforeUnmount } from 'vue'
import { initSocket, offEvent } from '@/config/socket'
import { useProfileStore } from '@/stores/profile.store'
import { useSubscriptionStore } from '@/stores/subscription.store'
import { useWalletStore } from '@/stores/wallet.store'
import { useCarteStore } from '@/stores/carte.store'

/**
 * Composable that listens to Socket.IO `data.updated` events
 * and invalidates/refreshes the relevant Pinia stores.
 *
 * Usage: call `useDataSocket()` in AuthenticatedLayout setup().
 */
export function useDataSocket() {
  let handler: ((data: { type: string }) => void) | null = null

  onMounted(() => {
    const socket = initSocket()
    if (!socket) return

    handler = (data: { type: string }) => {
      const { type } = data

      if (type === 'wallet') {
        useWalletStore().invalidateBalance()
        useWalletStore().fetchBalance(true)
        useWalletStore().fetchRecentTransactions()
      } else if (type === 'carte') {
        useCarteStore().invalidate()
        useCarteStore().fetchCartes(true)
      } else if (type === 'souscription') {
        useSubscriptionStore().fetchSouscription(true)
      } else if (type === 'profile') {
        useProfileStore().fetchProfil(true)
      }
    }

    socket.on('data.updated', handler)
  })

  onBeforeUnmount(() => {
    if (handler) {
      offEvent('data.updated', handler)
      handler = null
    }
  })
}
